import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from "@shared/models/dialog.model";
import {Subject} from "rxjs";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
    standalone: false,
    selector: 'particle-submit-response',
  templateUrl: './submit-response.component.html',
  styleUrls: ['./submit-response.component.scss']
})
export class SubmitResponseComponent implements OnInit, IDialogView, OnDestroy {
  data: DialogModel;
  unsubscribe$ = new Subject<void>();
  inputForm: FormGroup;
  constructor(private formBuilder: FormBuilder) {

  }

  ngOnInit() {
    this.inputForm = this.formBuilder.group({
      status : [this.data.input.status, Validators.required],
      description : [this.data.input.description, Validators.required]
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onOkClicked(): boolean {
    const status = this.inputForm.controls['status'].value;
    const description = this.inputForm.controls['description'].value;
    this.data.input.status = status;
    this.data.input.description = description;
    return true;
  }

}
